import { useState } from "react";
import { Sun, Moon } from "lucide-react";
import { getTheme, toggleTheme } from "../lib/theme";

export const ThemeToggle = () => {
  const [theme, setTheme] = useState(getTheme);
  const dark = theme === "dark";
  return (
    <button
      type="button"
      data-testid="theme-toggle"
      aria-label={dark ? "Passer en mode clair" : "Passer en mode sombre"}
      title={dark ? "Mode clair" : "Mode sombre"}
      onClick={() => setTheme(toggleTheme())}
      className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-border bg-[hsl(var(--surface))] text-[hsl(var(--fg-secondary))] transition-colors hover:border-[hsl(var(--brand))] hover:text-[hsl(var(--brand))]"
    >
      {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
};
